const WARNING_THRESHOLD = 6;

export const validateQty = (items, setMaxBigQuantity) => {
  if (!items) {
    return false;
  }
  let isMaxQty = false;
  let maxQuantity = 0;
  items.forEach((currentItem) => {
    if (currentItem.quantity > maxQuantity) {
      maxQuantity = currentItem.quantity;
    }
    if (currentItem.product_id === 0) {
      console.warn("APPROVING WITH EMPTY ITEM");
    }
  });
  if (maxQuantity > WARNING_THRESHOLD) {
    setMaxBigQuantity(maxQuantity);
    isMaxQty = true;
  }
  return isMaxQty;
};
